// src/components/LogoutAnimation.jsx

import React, { useEffect } from 'react';
import Lottie from 'lottie-react';
import { Center, Fade, VStack, Heading } from '@chakra-ui/react';
// Puedes usar una animación Lottie diferente para el logout si tienes una.
// Por ahora, reutilizaremos la de login-success.
import logoutAnimationData from '../assets/logout.json'; 

export default function LogoutAnimation({ onComplete }) {
  useEffect(() => {
    // Duración de la animación en pantalla
    const timer = setTimeout(() => {
      // Llama a la función onComplete para que el contexto finalice el cierre de sesión
      onComplete();
    }, 2500); // 2.5 segundos

    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <Fade in={true}>
      <Center
        position="fixed"
        top="0"
        left="0"
        w="100vw"
        h="100vh"
        bg="gray.800" // Fondo oscuro
        zIndex="9999"
      >
        <VStack spacing={8}>
          <Lottie 
            animationData={logoutAnimationData} 
            loop={true}
            style={{ width: 300, height: 300 }}
          />
          <Heading 
            size="lg" 
            color="white"
            textAlign="center" 
            maxW="600px" 
            px={4}
          >
            ¡No olvides calentar antes de jugar. Éxito!
          </Heading>
        </VStack>
      </Center>
    </Fade>
  );
}